import * as React from "react";
import {Fragment} from "react";
import PageHeaderView from "../body/PageHeaderView";
import PageContentView from "../body/PageContentView";
import {connect} from "react-redux";
import {RootState} from "../../store/reducer/root/RootState";
import {option, Option} from "ts-option";
import IndividualContactsTable, {DetailedContact} from "./table/IndividualContactsTable";
import CreateContactButton from "./CreateContactButton";
import ContactListEmptyView from "./ContactListEmptyView";
import Spinner from "../../hiberUiKit/src/atoms/Spinner/Spinner";
import ButtonGroupWrapper from "../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import Switch from "../../hiberUiKit/src/atoms/Switch/Switch";
import {ContactsListFilter} from "../../store/local/model/ContactsListFilter";
import LocalStorage from "../../store/local/LocalStorage";
import * as _ from "underscore";
import {Dispatch} from "redux";
import {notifyBugsnagAndShowToast} from "../../utils/Utils";
import {fetchIndividualContacts} from "../../store/action/contacts/contacts";
import {PartnerBrandSearch} from "../../model/partnerBrand/PartnerBrand";
import {OnFailure} from "../../store/action/actionHelpers";
import {fetchPartnerBrands} from "../../store/action/partnerBrand/partnerBrand";

const spinner = require("./../../../resources/hiber/img/spinner-orange.png");

interface ReduxProps {
	/**
	 * List with individual contacts.
	 */
	detailedContacts: Option<DetailedContact[]>,
	/**
	 * Indicates if all contacts are fetched
	 */
	allContactsFetched: boolean
	/**
	 * Partner brands
	 */
	partnerBrands: { [key: string]: PartnerBrandSearch }
}

interface State {
	/**
	 * Contacts list filter.
	 */
	filter: ContactsListFilter;
}

interface DispatchProps {
	fetchContacts: () => void;
	fetchPartnerBrands: (ids: string[], onFailure: OnFailure) => void
}

type Props = ReduxProps & DispatchProps;

/**
 * Contacts list view.
 */
class ContactsList extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {filter: LocalStorage.getContactsListFilter()};
	}

	componentDidMount() {
		if (!this.props.allContactsFetched) {
			this.props.fetchContacts();
		}
		else {
			this.fetchPartnerBrands();
		}
	}

	componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any): void {
		if (this.props.allContactsFetched != nextProps.allContactsFetched) {
			this.fetchPartnerBrands(nextProps)
		}
	}

	fetchPartnerBrands(props = this.props) {
		const pbids: string[] = props.detailedContacts.getOrElse([])
			.filter(dc => dc.contact.data.partnerBrandId.isDefined && !this.props.partnerBrands[dc.contact.data.partnerBrandId.orNull])
			.map(dc => dc.contact.data.partnerBrandId.get)
		props.fetchPartnerBrands(pbids, (e) => notifyBugsnagAndShowToast(e, "Fetch partner brands"))
	}

	render() {
		if (this.props.detailedContacts.isEmpty || !this.props.allContactsFetched) {
			return (
				<Spinner imgUrl={spinner} size={72}/>
			);
		}
		else if (this.props.detailedContacts.get.length) {
			const contacts = this.props.detailedContacts.getOrElse([])
				.filter(dc => this.state.filter.hideArchivedContacts ? !dc.contact.data.archived : true);
			return (
				<Fragment>
					<PageHeaderView>
						<CreateContactButton/>
						<ButtonGroupWrapper isRight>
							<Switch label={"Hide archived contacts"}
									checked={this.state.filter.hideArchivedContacts}
									onChange={(checked) => this.setState(
										{filter: this.state.filter.updateArchivedContacts(checked)})}/>
						</ButtonGroupWrapper>
					</PageHeaderView>
					<PageContentView>
						<IndividualContactsTable detailedContacts={contacts}/>
					</PageContentView>
				</Fragment>
			);
		}
		else {
			return <ContactListEmptyView/>
		}
	}
}

function mapStateToProps(state: RootState) {
	const partnerBrands = state.partnerBrand.partnerBrandsSearchMap;
	const contacts = option(_.values(state.contact.individualContactMap));
	const detailedContacts: Option<DetailedContact[]> = contacts.map(tab => tab.map(contact => {
		const partnerBrand = contact.data.partnerBrandId.flatMap(pbId => option(partnerBrands[pbId]));
		return {contact, partnerBrand};
	}));
	return {
		detailedContacts,
		allContactsFetched: state.contact.allContactsFetched,
		partnerBrands
	};
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchContacts: () => dispatch(fetchIndividualContacts(() => {},
			(err) => {notifyBugsnagAndShowToast(err, 'Fetch contacts')})),
		fetchPartnerBrands: (ids: string[], onFailure: OnFailure) => dispatch(fetchPartnerBrands(ids, () => {}, onFailure))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactsList)